var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerNav',{attrs:{"title":"授权证书"}}),_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }